'use es6';

import UIModal from 'UIComponents/dialog/UIModal';
import H3 from 'UIComponents/elements/headings/H3';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import reviewState from '../constants/reviewState';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import getEventKey from '../utils/getEventKey';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InformationModal = ({
  toggleModal,
  status,
  contentType,
  usageTracker
}) => {
  useEffect(() => {
    if (usageTracker && status && status !== reviewState.OK) {
      usageTracker.track(getEventKey(contentType), {
        action: 'info-modal-loaded'
      });
    }
  }, []); // eslint-disable-line

  if (!status || status === reviewState.OK) return null;
  return /*#__PURE__*/_jsxs(UIModal, {
    centered: true,
    onClick: evt => evt.stopPropagation(),
    "data-test-id": "modal-test",
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(H3, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `contentLabel.${status}.popupTitle`
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: toggleModal
      })]
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      className: "text-left",
      children: [status === reviewState.IN_REVIEW && /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `contentLabel.${status}.popupIntro.${contentType}`
      }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `contentLabel.${status}.popupTextForContent.${contentType}`
      })]
    }), /*#__PURE__*/_jsx(UIDialogFooter, {
      children: /*#__PURE__*/_jsx(UIButton, {
        use: "primary",
        onClick: toggleModal,
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `contentLabel.popupCloseButton`
        })
      })
    })]
  });
};
InformationModal.propTypes = {
  status: PropTypes.string.isRequired,
  toggleModal: PropTypes.func.isRequired,
  contentType: PropTypes.string.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  slaCopyType: PropTypes.string,
  usageTracker: PropTypes.object
};
export default InformationModal;